import { AgreementPlaceholderClass, splitAgreementPlaceholders } from 'bff'
import { translate } from 'i11n'
import { Fragment } from 'react'
import { cn } from '../lib/cn'
import { RichText } from './RichText'

const placeholderClassName: Record<AgreementPlaceholderClass, string> = {
  pending: 'border-zinc-400 bg-zinc-100 text-zinc-700',
  absent: 'border-red-400 bg-red-50 text-red-700',
  unknown_key: 'border-red-400 bg-red-50 text-red-700',
}

const placeholderLabel = (
  placeholderClass: AgreementPlaceholderClass,
  key: string,
) =>
  translate(`offer.agreement.placeholder.${placeholderClass}`, {
    label: translate(`offer.agreement.variables.${key}`, undefined, key),
    key,
  })

/**
 * Texto compilado de una conformidad. Un `final` es texto plano con el formato
 * liviano; una vista previa puede traer marcadores `⟦clase:clave⟧` (bff
 * `compileAgreementTemplate` con `placeholders: 'preview'`), que acá se dibujan
 * como etiquetas: gris lo que completa el reclamante, rojo lo que falta.
 */
export const AgreementRichText = ({
  text,
  rich = true,
}: {
  text: string
  rich?: boolean
}) => (
  <>
    {splitAgreementPlaceholders(text).map((segment, index) =>
      segment.kind === 'text' ? (
        rich ? (
          <RichText key={index} text={segment.text} />
        ) : (
          <Fragment key={index}>{segment.text}</Fragment>
        )
      ) : (
        <span
          key={index}
          data-placeholder={segment.class}
          className={cn(
            'mx-0.5 inline-block rounded border border-dashed px-1 align-baseline text-[8pt] font-medium leading-tight',
            placeholderClassName[segment.class],
          )}
        >
          {placeholderLabel(segment.class, segment.key)}
        </span>
      ),
    )}
  </>
)
